/** Ids and clock helpers shared by the MSW handler modules. Central ids are GUIDs. */

export const now = Date.now();
export const iso = (offsetMs: number) => new Date(now + offsetMs).toISOString();
export const mockDigest = (seed: string) => seed.repeat(64 / seed.length);
export const mockUserId = (n: number) => `10000000-0000-4000-8000-${String(n).padStart(12, '0')}`;

export const HOUR_MS = 60 * 60 * 1000;
export const DAY_MS = 24 * HOUR_MS;

export const CENTRAL_SSP_IDS = {
  'ssp-acme': '11111111-1111-1111-1111-111111111111',
  'ssp-secure': '22222222-2222-2222-2222-222222222222',
  'ssp-sentry': '33333333-3333-3333-3333-333333333333',
} as const;

export const CENTRAL_SSU_IDS = {
  'ssu-marina': 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
  'ssu-downtown': 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
  'ssu-yard': 'cccccccc-cccc-cccc-cccc-cccccccccccc',
} as const;

// Cameras, incidents, holds, searches and appliances all point at these sites.
export const marinaSiteId = '44444444-4444-4444-4444-444444444402';
export const downtownSiteId = '44444444-4444-4444-4444-444444444401';
export const serviceYardSiteId = '44444444-4444-4444-4444-444444444403';

// One admitted recorder per demo site; camera lists and Fleet admissions share its id.
export const siteNvrId = (siteId: string): string => `60000000${siteId.slice(8)}`;
